<template>
  <div id="auditoria-contratos-toolbar">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Contratos Auditados
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
};
</script>

<style>

</style>
